
import { jsPDF } from "jspdf";
import { TechneColors } from "../types";

/**
 * Add conclusion section
 */
export const addConclusion = (doc: jsPDF, { pageWidth, colors }: { pageWidth: number, colors?: TechneColors }): void => {
  const conclusionY = doc.lastAutoTable?.finalY ? doc.lastAutoTable.finalY + 20 : 180;
  
  // Add a new page for conclusion to avoid overcrowding
  doc.addPage();
  
  doc.setFontSize(16);
  doc.text("Conclusion", 15, 30);
  
  doc.setDrawColor(200, 200, 200);
  doc.line(15, 37, pageWidth - 15, 37);
  
  doc.setFontSize(11);
  const conclusionText = 
    "This assessment provides a starting point for enhancing your board's AI governance capabilities. " +
    "As AI technologies continue to evolve and their business implications grow, boards must develop robust " +
    "oversight practices that balance innovation with responsible use.\n\n" +
    "We recommend revisiting this assessment periodically to track your progress and adjust your approach " +
    "as needed. For further guidance on implementing these recommendations effectively, " +
    "please contact our team of AI governance experts.";
  
  // Increase line spacing by using splitTextToSize with more space
  const conclusionLines = doc.splitTextToSize(conclusionText, pageWidth - 40);
  doc.text(conclusionLines, 20, 50);
  
  // Remove the scheduling CTA as requested
};

